import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useUserService } from "../services/userService";

export function useIsNoShared() {
  const { projectId } = useParams<{ projectId: string }>();
  const { user } = useUserService();

  return useMemo(() => {
    if (!user || !user.id || !projectId) return false;
    return user.domains.some((domain) => +domain.id === +projectId);
  }, [user, projectId]);
}
